import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DateRangeDialogComponent } from '../date-range-dialog/date-range-dialog.component';

@Component({
    selector: 'hmt-custom-date-range-picker',
    templateUrl: './custom-date-range-picker.component.html',
    styleUrls: ['./custom-date-range-picker.component.scss'],
    standalone: false
})
export class CustomDateRangePickerComponent implements OnInit {
  @Output() dateRangeChange = new EventEmitter<{ start: Date; end: Date }>();
  rangeForm: FormGroup;

  constructor(private fb: FormBuilder, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.rangeForm = this.fb.group({
      start: [null],
      end: [null]
    });
  }

  get displayValue(): string {
    const { start, end } = this.rangeForm.value;
    if (start && end) {
      return `${this.formatDate(start)} to ${this.formatDate(end)}`;
    }
    return '';
  }

  openDialog(): void {
    const { start, end } = this.rangeForm.value;
    const dialogRef = this.dialog.open(DateRangeDialogComponent, {
      width: '400px',
      data: { start, end }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.start && result.end) {
        this.rangeForm.setValue({ start: result.start, end: result.end });
        this.dateRangeChange.emit(result);
      }
    });
  }

  private formatDate(date: Date): string {
    if (!date) return '';
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
